// export const filterEmptyValues = (obj) => {
//   if (!obj) return obj;

//   const filtered = {};

//   Object.entries(obj).forEach(([key, value]) => {
//     // Special handling for Date objects
//     if (value instanceof Date) {
//       filtered[key] = value;
//       return;
//     }

//     // Handle objects recursively (but not Dates which are also objects)
//     if (typeof value === "object" && value !== null && !Array.isArray(value)) {
//       const nestedFiltered = filterEmptyValues(value);
//       if (Object.keys(nestedFiltered).length > 0) {
//         filtered[key] = nestedFiltered;
//       }
//       return;
//     }

//     // Handle arrays
//     if (Array.isArray(value)) {
//       if (value.length > 0) {
//         filtered[key] = value;
//       }
//       return;
//     }

//     // Handle primitive values
//     if (value !== undefined && value !== null && value !== "") {
//       filtered[key] = value;
//     }
//   });

//   return filtered;
// };
export const filterEmptyValues = (obj) => {
  if (!obj) return obj;

  const filtered = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (value instanceof Date) {
      filtered[key] = value;
      return;
    }

    if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        const cleanedArray = value
          .map((item) =>
            typeof item === "object" && item !== null
              ? filterEmptyValues(item)
              : item
          )
          .filter((item) =>
            typeof item === "object"
              ? Object.keys(item).length > 0
              : item !== undefined && item !== null && item !== ""
          );

        if (cleanedArray.length > 0) {
          filtered[key] = cleanedArray;
        }
      } else {
        const nestedFiltered = filterEmptyValues(value);
        if (Object.keys(nestedFiltered).length > 0) {
          filtered[key] = nestedFiltered;
        }
      }

      return;
    }

    if (value !== undefined && value !== null && value !== "") {
      filtered[key] = value;
    }
  });

  return filtered;
};
